import * as THREE from "three";
import terrainVertexShader from "../shaders/terrain/vertex.glsl";
import terrainFragmentShader from "../shaders/terrain/fragment.glsl";

export function initTerrain(experience) {
  const floor = new THREE.PlaneGeometry(300, 300, 60, 60);
  const noise = experience.textureLoader.load("/noise/perlin_greyscale.png");
  const material = new THREE.ShaderMaterial({
    // wireframe: true,
    fragmentShader: terrainFragmentShader,
    vertexShader: terrainVertexShader,
    uniforms: {
      uNoise: new THREE.Uniform(noise),
    },
  });
  const floorMesh = new THREE.Mesh(floor, material);
  floorMesh.rotation.x = -Math.PI / 2;
  floorMesh.rotation.z = -2;
  experience.scene.add(floorMesh);

  experience.gui
    .add(floorMesh.rotation, "z")
    .min(-Math.PI)
    .max(Math.PI)
    .step(0.01)
    .name("floor.rotation.z");
}
